// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPreDetermination {
    static getAttributeTypeMap() {
        return MedicalBiPreDetermination.attributeTypeMap;
    }
}
MedicalBiPreDetermination.discriminator = undefined;
MedicalBiPreDetermination.additionalProperties = false;
MedicalBiPreDetermination.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "boolean"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "onFile",
        "baseName": "onFile",
        "type": "boolean"
    },
    {
        "name": "renewalProcessExists",
        "baseName": "renewalProcessExists",
        "type": "boolean"
    },
    {
        "name": "required",
        "baseName": "required",
        "type": "boolean"
    },
    {
        "name": "requirement",
        "baseName": "requirement",
        "type": "string"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPreDetermination.js.map